import axios from 'axios';

// Déterminer l'URL de base de l'API en fonction de l'environnement
const getApiBaseUrl = () => {
  const env = process.env.REACT_APP_ENV || 'development';
  
  if (env === 'production') {
    return process.env.REACT_APP_API_URL_PRODUCTION || 'https://manageo-api.hoststronger.site/api';
  }
  
  return process.env.REACT_APP_API_URL_DEVELOPMENT || 'http://localhost:8000/api';
};

const API_BASE_URL = getApiBaseUrl();

// Log pour vérifier l'URL utilisée (peut être retiré en production)
console.log('API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000, // 60 secondes
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
};

export const analysisAPI = {
  getCalls: (params = {}) => api.get('/analysis/calls', { params }),
  getStats: () => api.get('/analysis/stats'),
};

export const managerPhrasesAPI = {
  getAll: () => api.get('/manager-phrases/'),
  create: (data) => api.post('/manager-phrases/', data),
  getActive: () => api.get('/manager-phrases/active'),
  show: (id) => api.get(`/manager-phrases/${id}`),
  update: (id, data) => api.put(`/manager-phrases/${id}`, data),
  delete: (id) => api.delete(`/manager-phrases/${id}`),
};

export const agentStatsAPI = {
  getIdleTime: (params = {}) => api.get('/agent-stats/idle-time', { params }),
  forceSync: (data) => api.post('/agent-stats/sync', data),
  getAgentDetails: (agentId, params = {}) => api.get(`/agent-stats/agent/${agentId}/details`, { params })
};

export const ringoverStatsAPI = {
  getTimeBetweenCalls: (params = {}) => api.get('/ringover-stats/stored-stats', { params }),
  getRealtimeStats: (params = {}) => api.get('/ringover-stats/time-between-calls', { params })
};

export const evaluationCriteriaAPI = {
  getAll: () => api.get('/evaluation-criteria/'),
  create: (data) => api.post('/evaluation-criteria/', data),
  show: (id) => api.get(`/evaluation-criteria/${id}`),
  update: (id, data) => api.put(`/evaluation-criteria/${id}`, data),
  delete: (id) => api.delete(`/evaluation-criteria/${id}`),
  bulkUpdate: (data) => api.post('/evaluation-criteria/bulk-update', data),
  validatePercentages: (data) => api.post('/evaluation-criteria/validate-percentages', data),
  resetToDefault: () => api.post('/evaluation-criteria/reset-to-default')
};

export default api;
